// ============================================
// Google İşletme Reklam Verme - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleIsletmeReklamVermeContent: BlogContent = {
  tableOfContents: [
    { id: "isletme-profili", title: "Google İşletme Profili" },
    { id: "reklam-entegrasyonu", title: "Reklam Entegrasyonu" },
    { id: "optimizasyon", title: "Optimizasyon" },
    { id: "performans", title: "Performans Takibi" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google İşletme reklam verme</strong> ve profil optimizasyonu stratejileri."
    }
  ]
};

export default googleIsletmeReklamVermeContent;
